import * as React from 'react';
import { path } from 'ramda';
import { useMemo } from 'react';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { checkIsDigitCount, validateGte, validateLte } from './utils';
import { RawPriceRangeQuestionContainer } from './RawPriceRangeQuestionContainer';
import { EQuestionCode } from '../../types/form';
import { TValidators } from '../../utils/useSimpleForm';

export const PriceRangeQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { required, code },
  } = props;

  const validators: TValidators<string> = useMemo(() => {
    switch (code) {
      case EQuestionCode.PriceRange:
      case EQuestionCode.Price:
        return {
          gte: (value, values) => validateGte(value, path(['lte'], values) as string, required, checkIsDigitCount(5)),
          lte: (value, values) => validateLte(path(['gte'], values) as string, value, required, checkIsDigitCount(5)),
        };
      case EQuestionCode.PriceWithCommunal:
      case EQuestionCode.PriceRangeWithCommunal:
      case EQuestionCode.PriceRangeWithCommunalAndOperational:
        return {
          gte: (value, values) => validateGte(value, path(['lte'], values) as string, required, checkIsDigitCount(3)),
          lte: (value, values) => validateLte(path(['gte'], values) as string, value, required, checkIsDigitCount(3)),
        };
      default:
        return {
          gte: (value, values) => validateGte(value, path(['lte'], values) as string, required),
          lte: (value, values) => validateLte(path(['gte'], values) as string, value, required),
        };
    }
  }, [code, required]);

  return <RawPriceRangeQuestionContainer {...props} validators={validators} />;
};

PriceRangeQuestionContainer.displayName = 'PriceRangeQuestionContainer';
